// Disclaimer.js
import React from 'react';
import { Button, Divider, Row } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import {Brand} from "./Brand";
import {PLATFORM_AGREEMENT_DISCLAIMER} from "../Configs/DisclaimerText";


const Disclaimer = ({ onAgree, onClose, text=PLATFORM_AGREEMENT_DISCLAIMER}) => {
  return (
      <div>
          <div style={{ maxWidth: '60%', margin: 'auto' }}>
              {onClose && (
                  <div style={{ position: 'absolute', right: 10, top: 10 }}>
                    <Button icon={<CloseOutlined />} onClick={onClose} type="link" />
                  </div>
                )}
              <Brand companyId={'finiat'} maxHeight={'140px'} />
              <Divider />
                <div
                    className={'p-5'}
                    style={{
                      overflowY: 'auto',
                      margin: '20px 0',
                      borderRadius: '4px',
                      fontWeight: '500',
                      height: '60vh', // Adjust the height as necessary
                      fontFamily: "Roboto, sans-serif",
                      lineHeight: 2,
                      fontSize: '14px',
                    }}>
                  {text}
                </div>
              <Divider />
              <Row justify={'end'}>
                  <Button size={'large'} style={{borderRadius: '25px'}} type="primary" onClick={onAgree}>I Agree</Button>
              </Row>
            </div>
      </div>
  );
};

export default Disclaimer;
